export const countries = [
	{ index: '1', value: '1', label: 'United States' },
	{ index: '2', value: '2', label: 'Canada' },
	{ index: '3', value: '3', label: 'Mexico' },
];

export const usStates = [
	{ index: '1', value: '1', label: 'Alabama' },
	{ index: '2', value: '2', label: 'Alaska' },
	{ index: '3', value: '3', label: 'Arizona' },
	{ index: '4', value: '4', label: 'Arkansas' },
	{ index: '5', value: '5', label: 'California' },
	{ index: '6', value: '6', label: 'Colorado' },
	{ index: '7', value: '7', label: 'Connecticut' },
	{ index: '8', value: '8', label: 'Delaware' },
	{ index: '9', value: '9', label: 'Florida' },
	{ index: '10', value: '10', label: 'Georgia' },
	{ index: '11', value: '11', label: 'Hawaii' },
	{ index: '12', value: '12', label: 'Idaho' },
	{ index: '13', value: '13', label: 'Illinois' },
	{ index: '14', value: '14', label: 'Indiana' },
	{ index: '15', value: '15', label: 'Iowa' },
	{ index: '16', value: '16', label: 'Kansas' },
	{ index: '17', value: '17', label: 'Kentucky' },
	{ index: '18', value: '18', label: 'Louisiana' },
	{ index: '19', value: '19', label: 'Maine' },
	{ index: '20', value: '20', label: 'Maryland' },
	{ index: '21', value: '21', label: 'Massachusetts' },
	{ index: '22', value: '22', label: 'Michigan' },
	{ index: '23', value: '23', label: 'Minnesota' },
	{ index: '24', value: '24', label: 'Mississippi' },
	{ index: '25', value: '25', label: 'Missouri' },
	{ index: '26', value: '26', label: 'Montana' },
	{ index: '27', value: '27', label: 'Nebraska' },
	{ index: '28', value: '28', label: 'Nevada' },
	{ index: '29', value: '29', label: 'New Hampshire' },
	{ index: '30', value: '30', label: 'New Jersey' },
	{ index: '31', value: '31', label: 'New Mexico' },
	{ index: '32', value: '32', label: 'New York' },
	{ index: '33', value: '33', label: 'North Carolina' },
	{ index: '34', value: '34', label: 'North Dakota' },
	{ index: '35', value: '35', label: 'Ohio' },
	{ index: '36', value: '36', label: 'Oklahoma' },
	{ index: '37', value: '37', label: 'Oregon' },
	{ index: '38', value: '38', label: 'Pennsylvania' },
	{ index: '39', value: '39', label: 'Rhode Island' },
	{ index: '40', value: '40', label: 'South Carolina' },
	{ index: '41', value: '41', label: 'South Dakota' },
	{ index: '42', value: '42', label: 'Tennessee' },
	{ index: '43', value: '43', label: 'Texas' },
	{ index: '44', value: '44', label: 'Utah' },
	{ index: '45', value: '45', label: 'Vermont' },
	{ index: '46', value: '46', label: 'Virginia' },
	{ index: '47', value: '47', label: 'Washington' },
	{ index: '48', value: '48', label: 'West Virginia' },
	{ index: '49', value: '49', label: 'Wisconsin' },
	{ index: '50', value: '50', label: 'Wyoming' },
	{ index: '51', value: '51', label: 'Washington D.C.' },
];

export const canadaProvinces = [
	{ index: '1', value: '52', label: 'Alberta' },
	{ index: '2', value: '53', label: 'British Columbia' },
	{ index: '3', value: '54', label: 'Manitoba' },
	{ index: '4', value: '55', label: 'New Brunswick' },
	{ index: '5', value: '56', label: 'Newfoundland and Labrador' },
	{ index: '6', value: '57', label: 'Northwest Territories' },
	{ index: '7', value: '58', label: 'Nova Scotia' },
	{ index: '8', value: '59', label: 'Nunavut' },
	{ index: '9', value: '60', label: 'Ontario' },
	{ index: '10', value: '61', label: 'Prince Edward Island' },
	{ index: '11', value: '62', label: 'Quebec' },
	{ index: '12', value: '63', label: 'Saskatchewan' },
	{ index: '13', value: '64', label: 'Yukon' },
];

export const mexicoStates = [
	{ index: '1', value: '65', label: 'Aguascalientes' },
	{ index: '2', value: '66', label: 'Baja California' },
	{ index: '3', value: '67', label: 'Baja California Sur' },
	{ index: '4', value: '68', label: 'Campeche' },
	{ index: '5', value: '69', label: 'Chiapas' },
	{ index: '6', value: '70', label: 'Chihuahua' },
	{ index: '7', value: '71', label: 'Coahuila' },
	{ index: '8', value: '72', label: 'Colima' },
	{ index: '9', value: '73', label: 'Durango' },
	{ index: '10', value: '74', label: 'Guanajuato' },
	{ index: '11', value: '75', label: 'Guerrero' },
	{ index: '12', value: '76', label: 'Hidalgo' },
	{ index: '13', value: '77', label: 'Jalisco' },
	{ index: '14', value: '78', label: 'Mexico' },
	{ index: '15', value: '79', label: 'Mexico City' },
	{ index: '16', value: '80', label: 'Michoacan' },
	{ index: '17', value: '81', label: 'Morelos' },
	{ index: '18', value: '82', label: 'Nayarit' },
	{ index: '19', value: '83', label: 'Nuevo Leon' },
	{ index: '20', value: '84', label: 'Oaxaca' },
	{ index: '21', value: '85', label: 'Puebla' },
	{ index: '22', value: '86', label: 'Queretaro' },
	{ index: '23', value: '87', label: 'Quintana Roo' },
	{ index: '24', value: '88', label: 'San Luis Potosi' },
	{ index: '25', value: '89', label: 'Sinaloa' },
	{ index: '26', value: '90', label: 'Sonora' },
	{ index: '27', value: '91', label: 'Tabasco' },
	{ index: '28', value: '92', label: 'Tamaulipas' },
	{ index: '29', value: '93', label: 'Tlaxcala' },
	{ index: '30', value: '94', label: 'Veracruz' },
	{ index: '31', value: '95', label: 'Yucatan' },
	{ index: '32', value: '96', label: 'Zacatecas' },
];
